
(function MemberShipEvent() {
  async function logoutAjax() {
    try {
      const res = await fetch(`/account/logout`, {
        method: 'GET',
        headers: {
          'cache-control': 'max-age=0'
        }
      });
    } catch (err) {
    } finally {
      // 清空登陆状态
      T4SThemeSP.Cart.getToFetch();
      window.customer = null
    }
  }

  async function fetchUserPoints() {
    const res = await window.ogl_fetch.get(
      '/api/v1/customer-center/get-customer-points-list-paging',
      {
        customer_id: window.customer.id,
        current_page: 1,
        page_size: 1000
      }
    );
    const available_points = res.data?.total_list[0]?.available_points || 0;
    window.customer.total_points = available_points;
    return window.customer;
  }

  async function getPointsUpdateCouponEnable(option_doms) {
    try {
      const member_points_dom = document.querySelector(
        '#logined #member-points'
      );
      const selectSelected = document.querySelector('#select-selected .select-selected');
      const couponSelector = document.querySelector('.coupon-selector_wrapper .coupon-selector');
      const cusomter = await fetchUserPoints();
      member_points_dom &&
        (member_points_dom.innerText = cusomter.total_points);
      Shopify.analytics.publish("member-datac", {
        name: "point_report",
        customerId: window.customer_id || "",
        platform: !window.innerWidth < 768 ? "pc" : "mobile",
        point_value: cusomter.total_points
      });
      option_doms.forEach((option, index) => {
        const enable_option = Number(option.dataset.points) <= cusomter.total_points
        // 这里其实可以提早跳出循环，算了option不多
        if (index == 0 && !enable_option) {
          selectSelected.innerText = 'Unlock discount with 100 points'
          couponSelector.classList.add('disabled')
        }
        if (enable_option) {
          option.removeAttribute('data-disabled')
        }
      })
      return true
    } catch (err) {
      // 获取失败，登出刷新购物车
      return false
    }
  }

  /**
    请求后端积分兑换券code
    @params {
      redeem_type: 积分兑换券类型 
    }
  */
  async function redeemCoupon(redeem_type) {
    return await window.ogl_fetch.post(
      '/api/v1/customer-center/redeem-discount-code',
      {
        customer_id: window.customer.id,
        redeem_type: redeem_type,
        num: 1
      }
    );
  }

  /**
    请求后端积分兑换券code
    @params {
      coupon_code: 积分回退
    }
  */
  async function recallCoupon(coupon_code) {
    return await window.ogl_fetch.post(
      '/api/v1/customer-center/batch-recall-shopify-customer-discount-code',
      {
        shopify_discount_code_list: [coupon_code],
      }
    );
  }

  async function updateCoupon(coupon_code) {
    try {
      let formData = {
        discount: coupon_code
      };
      const res = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then((res) => res.json());
      // 更新cart信息，为了拿到当前在用券
      window.mibaoCartData = res
      const applicable = res?.discount_codes[0]?.applicable;
      if (res?.discount_codes[0] && !applicable) {
        window.oglToast.show({ message: `Sorry, Points couldn't be used with your existing discounts.` });
      }
    } catch (err) { }
  }

  window.handleRemoveCoupon = async function handleRemoveCoupon(current_code) {
    try {
      window.oglLoading(true)
      Shopify.analytics.publish("member-datac", {
        customerId: window.customer_id || "",
        platform: !window.innerWidth < 768 ? "pc" : "mobile",
        discount_code: current_code,
        name: 'remove_coupon',
      });
      const rest_code_list = window.mibaoCartData.cart_level_discount_applications.map(item => item.title).filter(code => code !== current_code)
      const rest_codes = rest_code_list.join(',')
      // 一定要先回退再更新购物车
      await recallCoupon(current_code)
      await updateCoupon(rest_codes)
      await T4SThemeSP.Cart.getToFetch()
      window.oglLoading(false)
    } catch (err) {
      window.oglToast.show({ message: 'Remove Coupon Fail!' })
      window.oglLoading(false)
    }
  }

  async function applyCoupon(redeem_type) {
    try {
      const res = await redeemCoupon(redeem_type)
      window.mibaoCartData = await fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then((res) => res.json());
      const coupon_code = `${res.data[0]?.discount_code},${window.mibaoCartData?.discount_codes?.map((item) => item.code).filter(code => code != res.data[0]?.discount_code).join(',')}`
      // 找不到折扣码终止请求
      if (!coupon_code) {
        throw ('no coupon_code return')
      }
      await updateCoupon(coupon_code);
      return true
    } catch (err) {
      window.oglToast.show({ message: 'Redeem Coupon Fail!' })
      return false
    } finally {
      await T4SThemeSP.Cart.getToFetch()
    }
  }

  let couponApplyLoading = false

  function publishMemberDatac(payload) {
    Shopify.analytics.publish("member-datac", {
      customerId: window.customer_id || "",
      platform: !window.innerWidth < 768 ? "pc" : "mobile",
      ...payload,
    });
  }

  function handleCouponDocumentClick() {
    const selectItems = document.getElementById('select-items');
    const selectSelected = document.getElementById('select-selected');
    if (!selectItems || !selectSelected) {
      return
    }
    selectItems.style.display = 'none';
    selectSelected.classList.remove('select-active');
  }

  async function handleApplyCouponAction(btn_dom) {
    if (couponApplyLoading || !btn_dom) {
      return
    }
    const spinner = btn_dom.querySelector('.t4s-loading__spinner')
    const btn_text = btn_dom.querySelector('.t4s-btn-atc_text')
    const couponSelector = document.querySelector('.coupon-selector_wrapper .coupon-selector');
    couponApplyLoading = true
    try {
      const hiddenInput = document.getElementById('CartDiscountcode');
      const selectedCouponCode = hiddenInput.value;
      if (!selectedCouponCode) {
        return
      }
      couponSelector?.classList.add('is-loading')
      btn_dom.classList.add('is-loading')
      spinner.style.display = 'block'
      btn_text.style.display = 'none'
      const applySuccess = await applyCoupon(selectedCouponCode);
      if (applySuccess) {
        Shopify.analytics.publish("member-datac", {
          customerId: window.customer_id || "",
          platform: !window.innerWidth < 768 ? "pc" : "mobile",
          name: 'cart_discount_code_apply',
        });
      }
    } catch (err) {
      window.report_faro({
        file_name: 'assets/init-event.js',
        func_name: 'handleApplyCouponAction',
        desc: 'Failed to apply the coupon code',
        error: err
      });
    } finally {
      couponApplyLoading = false
      couponSelector?.classList.remove('is-loading')
      btn_dom.classList.remove('is-loading')
      spinner.style.display = 'none'
      btn_text.style.display = 'block'
    }
  }

  // 点击 Apply 按钮只负责打开/关闭下拉
  function handleApplyBtnEvent(coupon_code) {
    const applyBtn = document.querySelector(
      '.coupon-selector_wrapper #coupon-apply'
    );
    const selectSelected = document.getElementById('select-selected');
    if (!applyBtn || !selectSelected) {
      return
    }
    applyBtn.onclick = function (event) {
      event.preventDefault();
      event.stopPropagation();
      selectSelected.click();
    };
  }

  // 下拉选项用券初始化
  var selectSelected = null

  function retryInitCoupon(e) {
    selectSelected = document.getElementById('select-selected');
    e.stopPropagation();
    initCouponSelect()
  }

  async function initCouponSelect() {
    selectSelected = document.getElementById('select-selected');
    //如果没有select-selected，那么就是不是下拉选项用券的逻辑
    if (!selectSelected) {
      return
    }
    const selectItems = document.getElementById('select-items');
    const options = document.querySelectorAll('.select-option');
    const hiddenInput = document.getElementById('CartDiscountcode');
    const applyBtn = document.querySelector(
      '.coupon-selector_wrapper #coupon-apply'
    );
    const load_res = await getPointsUpdateCouponEnable(options);
    if (!load_res) {
      // 加载失败，点击selected重置所有流程
      selectSelected.addEventListener('click', retryInitCoupon);
      return
    }

    selectSelected.removeEventListener('click', retryInitCoupon)

    // 点击选择框显示/隐藏选项
    selectSelected.onclick = function (e) {
      e.stopPropagation();
      const willOpen = selectItems.style.display !== 'block';
      if (willOpen) {
        closeAllSelect(this);
      }
      selectItems.style.display = willOpen ? 'block' : 'none';
      this.classList.toggle('select-active', willOpen);
      publishMemberDatac({
        name: 'cart_discount_select_click_' + (willOpen ? 'expand' : 'collapse'),
      });
    };

    // 点击选项
    options.forEach((option, index) => {
      option.onclick = async function () {
        const disabled = this.getAttribute('data-disabled');

        const points = this.getAttribute('data-points');
        publishMemberDatac({
          name: 'cart_discount_select_option',
          point_value: points,
        });

        if (disabled == 1) {
          return;
        }
        const value = this.getAttribute('data-value');
        const text = this.textContent;

        // 更新显示和隐藏输入值
        const selectValueBox = selectSelected.querySelector('.select-selected');
        selectValueBox.textContent = text;
        hiddenInput.value = value;

        // 移除所有选项的active类并添加当前选项的active类
        options.forEach((opt) => opt.classList.remove('select-option-active'));
        this.classList.add('select-option-active');

        // 关闭下拉框
        selectItems.style.display = 'none';
        selectSelected.classList.remove('select-active');
        await handleApplyCouponAction(applyBtn);
      };
    });

    // 点击页面其他地方关闭下拉框
    document.removeEventListener('click', handleCouponDocumentClick);
    document.addEventListener('click', handleCouponDocumentClick);

    // 关闭其他打开的下拉框
    function closeAllSelect(elmnt) {
      const selectItems = document.getElementsByClassName('select-items');
      const selectSelected = document.getElementsByClassName('select-selected');

      for (let i = 0; i < selectSelected.length; i++) {
        if (elmnt !== selectSelected[i] && elmnt !== selectItems[i]) {
          selectSelected[i].classList.remove('select-active');
        }
      }

      for (let i = 0; i < selectItems.length; i++) {
        if (elmnt !== selectItems[i]) {
          selectItems[i].style.display = 'none';
        }
      }
    }
  }

  window.memberPolicyClick = function memberPolicyClick() {
    document.querySelector('#rules-modal-href')?.click()
    publishMemberDatac({
      name: 'member-policy-click',
    });
  }

  function cartLoginBannerInit() {
    initCouponSelect();
    handleApplyBtnEvent();
  }

  function onLogined() {
    T4SThemeSP.MobileNav(false)
    window.customer && cartLoginBannerInit();
  }

  document.addEventListener('data-collection-open-drawer', function () {
    Shopify.analytics.publish("member-datac", {
      customerId: window.customer_id || "",
      platform: window.innerWidth > 768 ? "pc" : "mobile",
      name: 'mini_cart_open'
    });
  })

  $(window).on('cart:inited', function () {
    // onColorSwatchChange()
    window.customer?.id && cartLoginBannerInit();
  })

  $(window).on('cart:updated', function () {
    // onColorSwatchChange()
    window.customer?.id && cartLoginBannerInit();
  })

  // 购物车页面初始化
  if (meta.page.pageType == 'cart') {
    window.addEventListener("DOMContentLoaded", function () {
      cartLoginBannerInit();
      window.handleCartChange('.t4s-main-cart')
    })
  }

  document.addEventListener('logined', onLogined);

  if (window.customer?.id) {
    const loginEvent = new CustomEvent('logined');
    document.dispatchEvent(loginEvent)
  }
})();
